export const Logo = ({ dark = false, size = "h-11" }) => (
  <span className="flex items-center gap-3">
    <img src={dark ? "/images/brand/amora-mark.png" : "/images/brand/amora-mark-light.png"} alt="Amora Painting logo" className={`${size} w-auto`} />
    <span className={`font-display text-[15px] font-extrabold uppercase leading-[1.05] tracking-[0.08em] ${dark ? "text-navy" : "text-white"}`}>
      Amora<br />Painting
    </span>
  </span>
);
